import { createGenericDispatcher } from '../../action/action-dispatcher-factory';

import { AccountApiClient } from '../../api/account-api-client';

export const updateBasePlan = (accountId: number, basePlanUpdate: BasePlanUpdateRequest) =>
  createGenericDispatcher({
    name: 'UPDATE_BASE_PLAN',
    loadFunction: () => new AccountApiClient(accountId).updateBasePlan(basePlanUpdate),
    args: {
      accountId,
      basePlanUpdate,
    },
  });
